import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import MaskedInput from "react-text-mask";
import axios from "axios";
import { useTranslation } from "react-i18next";

const RegisterForm = () => {
    const { t } = useTranslation();
    const [success, setSuccess] = useState(null)

    const validationSchema = Yup.object({
        name: Yup.string().required(t("* İsim zorunludur.")),
        surname: Yup.string().required(t("* Soyisim zorunludur.")),
        phoneNumber: Yup.string()
            .matches(/^\d{3} \d{3} \d{4}$/, t("* Telefon numarası 555 555 5555 formatında olmalıdır."))
            .required(t("* Telefon numarası zorunludur.")),
        email: Yup.string().email("* Geçerli bir e-posta adresi giriniz.").required(t("* E-posta adresi zorunludur.")),
        acceptTerms: Yup.boolean()
            .oneOf([true], t("* Devam etmek için şartları kabul etmelisiniz."))
            .required(t("* Devam etmek için şartları kabul etmelisiniz.")),
    });

    const initialValues = {
        name: "",
        surname: "",
        phoneNumber: "",
        email: "",
        acceptTerms: false,
    };

    const handleSubmit = async (values, { resetForm }) => {
        // API'nin beklediği alan isimleriyle eşleştirme
        const payload = {
            approvedConditions: values.acceptTerms,
            email: values.email,
            firstName: values.name,
            lastName: values.surname,
            phone: values.phoneNumber.replace(/\s/g, ""), // Boşlukları kaldırıyoruz
        };
        const url = (window.location.origin.includes("localhost") || window.location.origin.includes("test")) ? "https://paragon.testmedici.com" : window.location.origin;
        try {
            const response = await axios.post(`${url}/api/v1/Submit?brand=0`, payload);
            console.log("API Yanıtı:", response.data);
            setSuccess(true);
            resetForm();

            setTimeout(() => {
                setSuccess(null);
            }, 3000);
        } catch (error) {
            console.error("API Hatası:", error);
            setSuccess(false);
            setTimeout(() => {
                setSuccess(null);
            }, 3000);
        }
    };

    return (
        <div className="contact-form-content shadow">
            <h2>{t("Hesap Oluşturma Formu")}</h2>
            <p className="mb-0">{t("Hızlı ve güvenli bir şekilde yatırım dünyasına adım atın.")}</p>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
            >
                {({ setFieldValue, isSubmitting }) => (
                    <Form className="mt-4">
                        {/* Form Alanları */}
                        <div className="mb-4">
                            <Field type="text" id="name" name="name" className="form-control" placeholder={t("İsim")} />
                            <ErrorMessage name="name" component="div" className="text-danger contact-error" />
                        </div>

                        <div className="mb-4">
                            <Field type="text" id="surname" name="surname" className="form-control" placeholder={t("Soyisim")} />
                            <ErrorMessage name="surname" component="div" className="text-danger contact-error" />
                        </div>

                        <div className="mb-4">
                            <Field name="phoneNumber">
                                {({ field }) => (
                                    <MaskedInput
                                        {...field}
                                        mask={[
                                            /[1-9]/,
                                            /\d/,
                                            /\d/,
                                            " ",
                                            /\d/,
                                            /\d/,
                                            /\d/,
                                            " ",
                                            /\d/,
                                            /\d/,
                                            /\d/,
                                            /\d/,
                                        ]}
                                        placeholder={t("Telefon Numarası")}
                                        guide={false}
                                        className="form-control"
                                        onChange={(e) => setFieldValue("phoneNumber", e.target.value)}
                                    />
                                )}
                            </Field>
                            <ErrorMessage name="phoneNumber" component="div" className="text-danger contact-error" />
                        </div>

                        <div className="mb-4">
                            <Field type="email" id="email" name="email" className="form-control" placeholder={t("E-posta Adresi")} />
                            <ErrorMessage name="email" component="div" className="text-danger contact-error" />
                        </div>

                        <div className="mb-4">
                            <div className="checkbox-wrapper-4">
                                <Field type="checkbox" id="acceptTerms" name="acceptTerms" className="inp-cbx" />
                                <label className="cbx d-flex align-items-start" htmlFor="acceptTerms">
                                    <span style={{ width: 20, height: 17 }}>
                                        <svg width="10px" height="10px">
                                            <use xlinkHref="#check-4" />
                                        </svg>
                                    </span>
                                    <span style={{ fontSize: 14 }}>{t("Kişisel Verilerin Korunması ve İşlenmesi Sözleşmesi'ni kabul ediyorum.")}</span>
                                </label>
                                <svg className="inline-svg">
                                    <symbol id="check-4" viewBox="0 0 12 10">
                                        <polyline points="1.5 6 4.5 9 10.5 1" />
                                    </symbol>
                                </svg>
                            </div>
                            <ErrorMessage name="acceptTerms" component="div" className="text-danger contact-error" />
                        </div>

                        {/* Buton */}
                        {
                            success === true ? (
                                <button type="button" className="btn-primary-v2 bg-success text-white w-100" disabled>
                                    {t("Başarılı")}
                                </button>
                            ) : success === false ? (
                                <button type="button" className="btn-primary-v2 bg-danger text-white w-100" disabled>
                                    {t("Lütfen tekrar deneyin.")}
                                </button>
                            ) : (
                                <button type="submit" className="btn-primary-v2 w-100" disabled={isSubmitting}>
                                    {isSubmitting ? t("Gönderiliyor...") : t("Gönder")}
                                </button>
                            )
                        }
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default RegisterForm;
